import axios from 'axios';

const API_URL = process.env.REACT_BASE_URL || "https://api.cadmaxpro.com/api";

// || "http://localhost:5000/api         //     https://api.cadmaxpro.com/api"
function getToken() {
  if (typeof window !== 'undefined') {
    const data = localStorage.getItem('token');
    return data;
  }
  return null;
}

let Api = axios.create({
  baseURL: API_URL,
  headers: {
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
    // "Content-Type": "multipart/form-data",
  }
});

Api.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token !== null) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const ApiallowFile = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
  },
});

ApiallowFile.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token !== null) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { Api, ApiallowFile };